import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { Locale } from '~model';
import store from '~store';
import Flag from '~widget/CountryFlag.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  props: {
  /* Boolean if the component is mobile (true) or not mobile / desktop (false) */
  mobile: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const getters = store?.getters;

const locales = computed(() => getters.getConfigLocales);
const getLocale = computed(() => getters.getLocale);
const loading = computed(() => getters.getTranslationIsLoading);
const multipleLanguages = computed(() => getters.getConfigHasMultipleLanguages);

const locale = computed({
  // get locale "de-DE" or "it-CH" etc.
  get(): Locale {
    return getLocale.value;
  },

  // set locale "de-DE" or "it-CH" etc.
  set(l: Locale): void {
    store.dispatch('changeLanguage', { locale: l });
  },
});

return { __sfc: true,getters, locales, getLocale, loading, multipleLanguages, locale, Flag }
}

})